import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'antd';
import BreadCrumb from '../../../components/BreadCrumb';
import style from './index.scss';
import NSMatchingConfigListing from './nsListingMatchingConfig';
import Wait4Me from '../../../components/Wait4Me';
import { ROUTE_AMLS_SMART_SCREENING } from '../../constants/globalConstants';

import { checkAccess } from '../../common/utils/index';

const resourceCode = 'APP_3_RESOURCE_UI_NS_IAD_MATCHING_CONFIG';

export const MatchingConfig = ({
  apiActions,
  settings,
  matchingConfigListData,
  authentication
}) => {
  const {
    navigateTo,
    saveNSMatchingConfigToStore,
    getNSGlobalSettingsPageInfo
  } = apiActions;

  useEffect(() => {
    getNSGlobalSettingsPageInfo({ pageId: 'NS_IAD_MATCHING_CONFIG_LIST' });
  }, []);

  const routeHandlder = (path) => {
    saveNSMatchingConfigToStore({
      matchingConfigurationName: null,
      matchingConfigurationParameters: null
    });
    navigateTo(path);
  };

  const getGSConfig = (q) => {
    if (settings?.nsSetting?.data?.uiWidgetGroups) {
      const groups = settings.nsSetting.data.uiWidgetGroups;
      return groups
        .find((g) => g.widgetGroupId === q.widgetGroupId)
        ?.widgets.find((w) => w.widgetId === q.widgetId);
    }
    return {};
  };

  return (
    <Row>
      <Col span={24}>
        <div className={style.wrapper}>
          <div className={style.head}>
            <BreadCrumb crumbs={[{ label: 'Matching Configuration' }]} />
            <div className={style.head_content}>
              <h4>Matching Configuration</h4>
              {checkAccess(authentication, resourceCode, 'Write') && (
                <button
                  id="matchingConfig-createBtn"
                  onClick={() =>
                    routeHandlder(
                      `${ROUTE_AMLS_SMART_SCREENING}/MatchingConfig/create`
                    )
                  }
                  className={style.btn_primary}>
                  Create
                </button>
              )}
            </div>
          </div>
          {settings?.nsSetting?.isLoading ? (
            <div className={style.loadingWrapper}>
              <Wait4Me />
            </div>
          ) : (
            <NSMatchingConfigListing
              GSConfigMatchingListing={getGSConfig({
                widgetGroupId: 'NS_IAD_MATCHING_CONFIG_LIST_GROUP',
                widgetId: 'NS_IAD_MATCHING_CONFIG_LIST'
              })}
              apiActions={apiActions}
              matchingConfigListData={matchingConfigListData}
              authentication={authentication}
            />
          )}
        </div>
      </Col>
    </Row>
  );
};

MatchingConfig.propTypes = {
  apiActions: PropTypes.object,
  settings: PropTypes.object,
  matchingConfigListData: PropTypes.object,
  authentication: PropTypes.object
};

export default MatchingConfig;
